
      import API from "!../../../../../../node_modules/.deno/style-loader@3.3.4/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../node_modules/.deno/style-loader@3.3.4/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../node_modules/.deno/style-loader@3.3.4/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../node_modules/.deno/style-loader@3.3.4/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../node_modules/.deno/style-loader@3.3.4/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../node_modules/.deno/style-loader@3.3.4/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../../../../node_modules/.deno/postcss-loader@7.3.4/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!../../../../../../node_modules/.deno/sass-loader@13.3.3/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[4].use[3]!./DataHistoryRow.module.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../../../../node_modules/.deno/postcss-loader@7.3.4/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!../../../../../../node_modules/.deno/sass-loader@13.3.3/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[4].use[3]!./DataHistoryRow.module.scss";
       export default content && content.locals ? content.locals : undefined;
